import type { FilterValue } from '../definitions/filter-option';

/**
 * transform value to request query
 */
export function toRequestQuery(value?: FilterValue): Array<number> {
    return Array.isArray(value)
        ? value
            .map(x => +x)
            .filter(x => !isNaN(x))
        : typeof value === 'number'
            ? [value]
            : [];
}
